import { zergApi } from "@/service/zerg";

class ServiceOrdersService {

    async getServiceOrders(params) {
        try {
            const data = await zergApi.post('/operations/service-orders/get-service-orders', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async createServiceOrder(params) {
        try {
            const data = await zergApi.post('/operations/service-orders/create-service-order', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updateServiceOrder(params) {
        try {
            const data = await zergApi.put('/operations/service-orders/update-service-order', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getServicesWithoutTravel() {
        try {
            const data = await zergApi.get("/operations/service-orders/get-services-without-travel");
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getServiceOrderById(params) {
        try {
            const data = await zergApi.get("/operations/service-orders/get-service-order-by-id", { params });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getOrdersDetails(params) {
        try {
            const data = await zergApi.get("/operations/service-orders/get-orders-details", { params });
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new ServiceOrdersService();